import React from 'react';

import './Pages.css';

import {Container,Col, Row,Nav} from 'react-bootstrap';
import {Helmet} from "react-helmet";


function pages (props) {

	
   return (
       

      <Container>
<Helmet>
                <meta charSet="utf-8" />
					<title>{props.page.pageName}</title>
					<meta name="description" content={props.page.pageName}   />
					
                <link rel="canonical" href="http://shop.com/product" />
            </Helmet>
        
    <Row >
		<Col >
			<Nav>
				<ol className="breadcrumb">
					<li className="breadcrumb-item">
						<a href="/">Home</a>
					</li>
					
					<li className="breadcrumb-item active">
	{props.page.pageName}
					</li>
				</ol>
			</Nav>
		</Col>
	</Row>
  
  <div className="row product-detail-page">
		<div className="col-md-6">
     <h1 className="product-title"> {props.page.pageName} <p></p> </h1>
   
		</div>
		
	</div>

  <div className="row">
		<div className="col-md-12">
      
			<dl>
				<dt>
					
				</dt>
				<dd>
				<div dangerouslySetInnerHTML={{ __html: props.page.pageContent }} /></dd>
				
			</dl>
		</div>
	</div>  


</Container>              
            
      
        
        );
	}

export default pages;